const AdvanceType = {
  ADVANCE: 'advance',
  CLOSE: 'close',
  CLOSEVOID: 'closevoid',
  DRAFT: 'draft',
  NONE: 'none',
  REVISION: 'revision',
  CLOSESTRAND: 'closestrand',
  properties: {
    advance: {
      value: 'advance'
    },
    close: {
      value: 'close'
    },
    closevoid: {
      value: 'closevoid'
    },
    draft: {
      value: 'draft'
    },
    none: {
      value: 'none'
    },
    revision: {
      value: 'revision'
    },
    closestrand: {
      value: 'closestrand'
    }
  }
}

export { AdvanceType }
